import { LogLevel } from "@shared/services/log-level";
var Environment = {
    production: false,
    vdotAppUrl: "https://app.staging.vdoto2.com",
    logLevel: LogLevel.debug
};
if (process.env.NODE_ENV === "production") {
    Environment.production = true;
    Environment.vdotAppUrl = "https://app.vdoto2.com";
    Environment.logLevel = LogLevel.warning;
}
else if (process.env.NODE_ENV === "local") {
    Environment.vdotAppUrl = "http://localhost:8086";
}
else if (process.env.NODE_ENV === "webdev") {
    Environment.vdotAppUrl = "https://localhost:44201";
}
export default Environment;



//////////////////
// WEBPACK FOOTER
// ./app/shared/environment.ts
// module id = 7
// module chunks = 0 1 2 3 4 5